// tpemrt-future-v1: #c48c31
// v2, v3: #a1d884
// v4, v5, v6, v7: #FFDB00
// v8: #25aae1
// v9: #79bce8
// v10: #c3b091
// v11, v12: #e5554f
// v13 : #8A2BE2
// v14, v15: #556B2F

export const lines = [
  //v1
  {
    name: '淡水信義線－信義線',
    variant: 'tpemrt-future-v1',
    info: '已通車至象山，延伸段預計在2025年12月通車',
  },
  //v1-2
  {
    name: '機場捷運增設站',
    variant: 'tpemrt-future-v13',
    info: '尚未核定，僅供參考',
  },
  //v2
  {
    name: '萬大樹林線－第一階段',
    variant: 'tpemrt-future-v2',
    info: '興建中，預計2027年年底通車',
  },
  //v3
  {
    name: '萬大樹林線－第二階段',
    variant: 'tpemrt-future-v2',
    info: '站名暫定，2024年開工，拼2031年通車',
  },
  //v5
  {
    name: '環狀線－北環段',
    variant: 'tpemrt-future-v4',
    info: '2023年動工，站名暫定，拼2031年完工',
  },
  //v6
  {
    name: '環狀線－南環段',
    variant: 'tpemrt-future-v4',
    info: '2023年動工，站名暫定，拼2031年完工',
  },
  //v7
  {
    name: '環狀線-東環段',
    variant: 'tpemrt-future-v4',
    info: '站名暫定，拼2024年底開工',
  },
  //v8
  {
    name: '民生汐止線第一期',
    variant: 'tpemrt-future-v8',
    info: '規劃中，預計2025年動工，2032完工',
  },
  //v8-1
  {
    name: '民生汐止線第二期',
    variant: 'tpemrt-future-v8',
    info: '規劃中，尚未核定，僅供參考',
  },
  //v9
  {
    name: '三鶯線',
    variant: 'tpemrt-future-v9',
    info: '預計2025年完工',
  },
  //v10
  // {
  //   name: '安坑線',
  //   variant: 'tpemrt-future-v10',
  //   info: '興建中，預定完工年期2022年底',
  // },
  //v11
  //  {
  //    name: '淡海輕軌藍海線第一期',
  //    variant: 'tpemrt-future-v11',
  //    info: '預計2020年初通車',
  //  },
  //v12
  {
    name: '淡海輕軌藍海線第二期',
    variant: 'tpemrt-future-v11',
    info: '2024年3月交通部審查通過，待核定後預計五年後通車',
  },
  //v13
  {
    name: '五股泰山輕軌路網',
    variant: 'tpemrt-future-v2',
    info: '未核定，規劃階段，僅供參考',
  },
  //v14
  {
    name: '深坑輕軌路網',
    variant: 'tpemrt-future-v2',
    info: '未核定，可行性研究階段，僅供參考',
  },
  //v15
  {
    name: '八里輕軌路網',
    variant: 'tpemrt-future-v2',
    info: '未核定，可行性研究階段，僅供參考',
  },
   //v16
  {
    name: '泰山板橋輕軌路網',
    variant: 'tpemrt-future-v2',
    info: '未核定，可行性研究階段，僅供參考',
  },
]

export const stations = [
  [
    {
      name: '廣慈/奉天宮站',
      address: '',
      lat: 25.037921,
      lng: 121.582219,
    },
  ],
  // v1-2 機場捷運增設站
  [
    {
      name: 'A2a',
      address: '',
      lat: 25.066074,
      lng: 121.475087,
    },
    {
      name: 'A5a 塭仔圳',
      address: '',
      lat: 25.04714,
      lng: 121.43469,
    },
  ],
  // v2 萬大樹林線第一階段
  [
    {
      name: '植物園 LG02',
      address: '',
      lat: 25.030609,
      lng: 121.509231,
    },
    { name: '廈安站 LG03', address: '', lat: 25.03015, lng: 121.504202 },
    {
      name: '加蚋站 LG04',
      address: '',
      lat: 25.021759,
      lng: 121.498695,
    },
    {
      name: '永和永平國小站 LG05',
      address: '',
      lat: 25.00852,
      lng: 121.505596,
    },
    {
      name: '連城錦和站 LG07',
      address: '',
      lat: 24.996206,
      lng: 121.490058,
    },
    {
      name: '中和高中站 LG08',
      address: '',
      lat: 24.995121,
      lng: 121.480961,
    },
    {
      name: '莒光站 LG08A',
      address: '',
      lat: 24.996156,
      lng: 121.470163,
    },
  ],
  // v3 萬大樹林線第二階段
  [
    { name: '廷寮 LG09', address: '', lat: 24.989168, lng: 121.470207 },
    {
      name: '清水(中正國中) LG10',
      address: '',
      lat: 24.982814,
      lng: 121.455915,
    },
    {
      name: '土城 LG11',
      address: '新北市土城區金城路1段105號',
      lat: 24.972736,
      lng: 121.4436896,
    },
    { name: '埤塘 LG12', address: '', lat: 24.969229, lng: 121.440524 },
    {
      name: '城林橋 LG13',
      address: '',
      lat: 24.975321,
      lng: 121.438502,
    },
    { name: '溪洲 LG14', address: '', lat: 24.984648, lng: 121.426018 },
    { name: '彭厝 LG15', address: '', lat: 24.981585, lng: 121.419963 },
    { name: '備內 LG16', address: '', lat: 24.988279, lng: 121.415152 },
    { name: '樹林 LG17', address: '', lat: 24.996037, lng: 121.420836 },
    { name: '潭底 LG18', address: '', lat: 25.001037, lng: 121.425323 },
    {
      name: '監理所 LG19',
      address: '',
      lat: 25.007739,
      lng: 121.416867,
    },
    {
      name: '三多(三角埔) LG20',
      address: '',
      lat: 25.015328,
      lng: 121.410601,
    },
  ],
  // v4 環狀線北環段
  [
    {
      name: '故宮(外雙溪) Y28',
      address: '',
      lat: 25.098402,
      lng: 121.547393,
    },
    {
      name: '林子口(雙溪公園) Y27',
      address: '',
      lat: 25.096455,
      lng: 121.532007,
    },
    {
      name: '福德洋 Y25',
      address: '',
      lat: 25.093236,
      lng: 121.520073,
    },
    {
      name: '社子 Y24',
      address: '',
      lat: 25.087484,
      lng: 121.510717,
    },
    {
      name: '重陽橋 Y23',
      address: '',
      lat: 25.088102,
      lng: 121.493036,
    },
    { name: '分子尾 Y22', address: '', lat: 25.088904, lng: 121.485896 },
    { name: '中路 Y20', address: '', lat: 25.076573, lng: 121.468525 },
    { name: '更寮 Y19B', address: '', lat: 25.074797, lng: 121.460206 },
    {
      name: '工商展覽中心 Y19A',
      address: '',
      lat: 25.068054,
      lng: 121.451972,
    },
  ],
  // v5 環狀線南環段
  [
    {
      name: '遠東工業區 Y5',
      address: '',
      lat: 24.98345,
      lng: 121.54884,
    },
    {
      name: '溝子口(考試院) Y4',
      address: '',
      lat: 24.987307,
      lng: 121.548975,
    },
    { name: '馬明潭 Y3', address: '', lat: 24.988707, lng: 121.560275 },
    {
      name: '文山區公所 Y2A',
      address: '',
      lat: 24.990557,
      lng: 121.570817,
    },
    { name: '政大 Y1A', address: '', lat: 24.987726, lng: 121.575749 },
  ],
  // v7 環狀線東環段
  [
    {
      name: 'Y34',
      address: '',
      lat: 25.066698,
      lng: 121.574749,
    },
    {
      name: 'Y33',
      address: '',
      lat: 25.073213,
      lng: 121.579751,
    },
    {
      name: 'Y32',
      address: '',
      lat: 25.077396,
      lng: 121.572776,
    },
    {
      name: 'Y31',
      address: '',
      lat: 25.079738,
      lng: 121.567509,
    },
    {
      name: 'Y30',
      address: '',
      lat: 25.079939,
      lng: 121.558507,
    },
  ],
  // v8 民生汐止線第一期
  [
    { name: '汐止 SB15', address: '', lat: 25.064883, lng: 121.659281 },
    { name: '汐科 SB14', address: '', lat: 25.063369, lng: 121.649752 },
    {
      name: '樟樹灣 SB13',
      address: '25.060984, 121.642224',
      lat: 25.0608975,
      lng: 121.6421275,
    },
    {
      name: '社后 SB12',
      address: '福德一路至工建路段',
      lat: 0,
      lng: 0,
    },
    {
      name: '下社后 SB11',
      address: '',
      lat: 25.066088,
      lng: 121.622173,
    },
  ],
  // v8-1 民生汐止線第二期
  [
    {
      name: 'SB9',
      address: '',
      lat: 25.063112,
      lng: 121.603311,
    },
    {
      name: '(三軍總醫院) SB8',
      address: '',
      lat: 25.06913,
      lng: 121.592735,
    },
    { name: '舊宗 SB7', address: '', lat: 25.060245, lng: 121.579122 },
    {
      name: '(民生圓環) SB6',
      address: '',
      lat: 25.059163,
      lng: 121.563978,
    },
    {
      name: 'SB5',
      address: '',
      lat: 25.05822,
      lng: 121.553313,
    },
    {
      name: '(大稻埕碼頭) SB1',
      address: '',
      lat: 25.057315,
      lng: 121.513431,
    },
  ],
  // v9 三鶯線
  [
    {
      name: '媽祖田站 LB02',
      address: '',
      lat: 24.953782,
      lng: 121.412507,
    },
    {
      name: '長壽山 LB03',
      address: '',
      lat: 24.94364,
      lng: 121.401857,
    },
    { name: '橫溪 LB04', address: '', lat: 24.937573, lng: 121.391176 },
    {
      name: '龍埔(三峽廣行宮) LB05',
      address: '',
      lat: 24.939906,
      lng: 121.384563,
    },
    {
      name: '三峽(國家教育研究院) LB06',
      address: '',
      lat: 24.938968,
      lng: 121.376577,
    },
    {
      name: '台北大學(恩主公醫院) LB07',
      address: '',
      lat: 24.93911,
      lng: 121.367147,
    },
    {
      name: '鶯歌車站 LB08',
      address: '',
      lat: 24.95323,
      lng: 121.356603,
    },
    {
      name: '陶瓷老街 LB09',
      address: '',
      lat: 24.952427,
      lng: 121.34948,
    },
    { name: '國華 LB10', address: '', lat: 24.954374, lng: 121.342537 },
    {
      name: '永吉公園 LB11',
      address: '',
      lat: 24.960815,
      lng: 121.33425,
    },
    {
      name: '鶯桃福德 LB12',
      address: '',
      lat: 24.966811,
      lng: 121.329798,
    },
  ],

  //  [
  //    {
  //      name: '淡水漁人碼頭 V26',
  //      address: '',
  //      lat: 25.181644,
  //      lng: 121.418385,
  //    },
  //    { name: '沙崙 V27', address: '', lat: 25.187101, lng: 121.416883 },
  //    {
  //      name: '台北海洋學院 V28',
  //      address: '',
  //      lat: 25.191287,
  //      lng: 121.426705,
  //    },
  //  ],
  // v12 五股泰山輕軌路網
  [
    { name: 'V21', address: '', lat: 25.168699, lng: 121.444705 },
    { name: 'V22', address: '', lat: 25.172106, lng: 121.437238 },
    { name: 'V23', address: '', lat: 25.174489, lng: 121.433634 },
    { name: 'V24', address: '', lat: 25.17569, lng: 121.428386 },
    { name: 'V25', address: '', lat: 25.179189, lng: 121.421793 },
    { name: 'V26A', address: '', lat: 25.182596, lng: 121.419451 },
  ],
  // v13 五股泰山輕軌路網
  [
    { name: '分子尾站 F1', address: '', lat: 25.088904, lng: 121.485896 },
    { name: '樓厝站 F2', address: '', lat: 25.091085, lng: 121.484032 },
    { name: '水湳站 F3', address: '', lat: 25.094711, lng: 121.479092 },
    { name: '和尚港站 F4', address: '', lat: 25.094372, lng: 121.468352 },
    { name: '成子寮站 F6', address: '', lat: 25.100582, lng: 121.485896 },
    { name: '西雲寺站 F7', address: '', lat: 25.093663, lng: 121.448746 },
    { name: '洲子洋站 F8', address: '', lat: 25.089265, lng: 121.445247 },
    { name: '五股站 F9', address: '', lat: 25.082194, lng: 121.440893 },
    { name: '水碓站 F10', address: '', lat: 25.07464, lng: 121.436626 },
    { name: '楓樹腳站 F11', address: '', lat: 25.063411, lng: 121.43521 },
    { name: '坡雅頭站 F12', address: '', lat: 25.058221,  lng: 121.437590 },
    { name: '義學站 F13', address: '', lat: 25.051237,  lng: 121.432278, },
    { name: '塭仔圳站 F14', address: '', lat: 25.047140, lng:  121.434690 },
  ],
  // v14 深坑輕軌路網
  [
    { name: '公館後站 S2', address: '', lat: 25.001819, lng: 121.601039 },
    { name: '阿柔洋站 S3', address: '', lat: 25.000008, lng: 121.612839 },
    { name: '深坑國中站 S4', address: '', lat: 25.001055,  lng: 121.620457, },
    { name: '草地頭站 S5', address: '', lat: 25.005024, lng: 121.622247  }, 
  ],
  // v15 八里輕軌路網
  [
    { name: 'V25/31', address: '', lat: 25.179189,  lng:121.421793 },
    { name: 'V32', address: '', lat: 25.162020,  lng:121.412793  },
    { name: 'V33', address: '', lat: 25.159037,   lng:121.408661 },
    { name: 'V34', address: '', lat: 25.155159,   lng:121.404142 },
    { name: 'V35', address: '', lat: 25.151413,  lng:121.399654 },
    { name: 'V36', address: '', lat: 25.148035,  lng:121.397172  },
    { name: 'V37', address: '', lat: 25.142772,  lng:121.392064  },
  ],
  // v16 泰山板橋輕軌路網
  [
      { name: '塭仔圳站 F14', address: '', lat: 25.047140,  lng:121.434690,   },
      { name: '莒光站 F28', address: '', lat: 24.996156, lng:121.470163    },
  ]

    
]
